<template>
  <v-card flat>
    <v-card-title class="text-center justify-center">
      <v-btn absolute icon right @click="$emit('back')">
        <v-icon>mdi-arrow-right</v-icon>
      </v-btn>

      پیش زمینه
    </v-card-title>

    <v-tabs v-model="tabs" class="" grow>
      <v-tab class="rounded-t-lg mx-1 overflow-hidden">تصویر</v-tab>
      <v-tab class="rounded-t-lg mx-1 overflow-hidden">رنگ</v-tab>
      <v-tab class="rounded-t-lg mx-1 overflow-hidden">طیف رنگ</v-tab>
    </v-tabs>

    <v-tabs-items v-model="tabs">
      <v-tab-item>
        <together-ai-image @create="generateAi" />

        <v-card-subtitle class="px-4 pb-1"> تصاویر پیش فرض </v-card-subtitle>

        <div class="imported-images">
          <div v-if="defaultsLoading" class="d-flex align-center justify-center">
            <v-progress-circular indeterminate />
          </div>

          <template
            v-if="
              !defaultsLoading &&
              !!defaultsImages &&
              !!Object.keys(defaultsImages)?.length
            "
          >
            <div
              v-for="(image, i) in defaultsImages"
              :key="i"
              @click="setBg('image', image.path)"
            >
              <!-- <v-img
                :src="image.thumbnail_small"
                alt=""
                aspect-ratio="1"
                contain
                width="100%"
              /> -->

              <v-img :src="image.thumbnail_small" alt="" aspect-ratio="1" width="100%" />
            </div>
          </template>
        </div>
      </v-tab-item>

      <!-- <v-tab-item class="pa-4">
        <color-picker v-model="computedValue.color" />

        <v-row no-gutters>
          <v-col
            v-for="(color, i) in colors"
            :key="i"
            class="pa-2"
            cols="4"
            lg="2"
            md="3"
          >
            <v-avatar
              :color="color"
              class="rounded-lg border cursor-pointer"
              size="40"
              @click="setBg('color', color)"
            />
          </v-col>
        </v-row>
      </v-tab-item> -->

      <v-tab-item class="pa-4">
        <color-picker
          v-model="computedValue.color"
          @change="setBg('color', computedValue.color)"
        />

        <v-row no-gutters>
          <v-col
            v-for="(color, i) in colors"
            :key="i"
            class="pa-2"
            cols="4"
            lg="2"
            md="3"
          >
            <v-avatar
              :color="color"
              class="rounded-lg border cursor-pointer"
              size="40"
              @click="setBg('color', color)"
            />
          </v-col>
        </v-row>
      </v-tab-item>

      <v-tab-item class="pa-4">
        <!--        <v-slider append-icon="mdi-rotate-360" label="چرخش رنگ" max="360" min="0"-->
        <!--                  thumb-label track-color="grey" @input="$emit('update', true)">-->
        <!--          <template v-slot:thumb-label="{value}">-->
        <!--            <div class="d-flex align-center justify-center"-->
        <!--                 style="width: 20px;height: 20px;background-color: rgba(12,15,26,0.7);border-radius: 50%">-->
        <!--              {{ value }}°-->
        <!--            </div>-->
        <!--          </template>-->
        <!--        </v-slider>-->

        <v-row no-gutters>
          <v-col v-for="(color, i) in gradients" :key="i" class="pa-2" cols="4" md="3">
            <v-avatar
              :style="{
                background: `linear-gradient(180deg, ${color.colors[0]} 0%, ${color.colors[1]} 100%)`,
              }"
              class="border cursor-pointer"
              size="64"
              @click="setBg('gradient', color)"
            />
          </v-col>
        </v-row>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import { DesignImage } from "@/utilities/designImage";
import ColorPicker from "@/components/pickers/colorPicker.vue";
import { debounce } from "@/main";
import togetherAiImage from "../../view/pages/image/togetherAiImage.vue";

const design = new DesignImage();

export default {
  name: "designBgSelect",

  props: {
    value: Object,
  },

  components: { ColorPicker, togetherAiImage },

  data() {
    return {
      prompt: "",
      tabs: 0,
      loading: false,
      generatedImages: [],
      colors: [
        "#EC5252FF",
        "#C14444FF",
        "#EF717AFF",
        "#D95459FF",
        "#FF8976FF",
        "#F56149FF",
        "#F392B9FF",
        "#EA4C8CFF",
        "#5E345EFF",
        "#4F2B4FFF",
        "#B659ABFF",
        "#8F3D86FF",
        "#9B59B6FF",
        "#8E44ADFF",
        "#745EC5FF",
        "#5B48A2FF",
        "#5065A1FF",
        "#394C81FF",
        "#3498DBFF",
        "#2980B9FF",
        "#34495EFF",
        "#2C3E50FF",
        "#3A6F81FF",
        "#356272FF",
        "#345F41FF",
        "#2D5036FF",
        "#1ABC9CFF",
        "#16A085FF",
        "#2ECC71FF",
        "#27AE60FF",
        "#A5C63BFF",
        "#8EB021FF",
        "#F5C24EFF",
        "#FCB424FF",
        "#F68F30FF",
        "#C66913FF",
        "#79302AFF",
        "#662621FF",
        "#5E4534FF",
        "#503B2CFF",
        "#8E8271FF",
        "#7B7163FF",
        "#F0DEB4FF",
        "#D5C295FF",
        "#B8C9F1FF",
        "#99ABD5FF",
        "#ECF0F1FF",
        "#BDC3C7FF",
        "#95A5A6FF",
        "#7F8C8DFF",
        "#A0CECBFF",
        "#7DB1B1FF",
        "#CFF09EFF",
        "#A8DBA8FF",
        "#A7D2DBFF",
        "#84B0B9FF",
        "#FF3D7FFF",
        "#2DE2B5FF",
        "#69D2E7FF",
        "#FD8F52FF",
      ],
      gradients: [
        { type: "linear", colors: ["#FF9A9E", "#FAD0C4"] },
        { type: "linear", colors: ["#A18CD1", "#FBC2EB"] },
        { type: "linear", colors: ["#F6D365", "#FDA085"] },
        { type: "linear", colors: ["#D4FC79", "#96E6A1"] },
        { type: "linear", colors: ["#F1BEF7", "#C27BA5"] },
        { type: "linear", colors: ["#DFCB99", "#A69166"] },
        { type: "linear", colors: ["#A4E7D6", "#61C68C"] },
        { type: "linear", colors: ["#FDA893", "#D16E5E"] },
        { type: "linear", colors: ["#FEE370", "#E1C548"] },
        { type: "linear", colors: ["#84FAB0", "#8FD3F4"] },
        { type: "linear", colors: ["#A6C0FE", "#F68084"] },
        { type: "linear", colors: ["#30CFD0", "#330867"] },
        { type: "linear", colors: ["#FA709A", "#FEE140"] },
        { type: "linear", colors: ["#5EE7DF", "#B490CA"] },
        { type: "linear", colors: ["#667EEA", "#764BA2"] },
        { type: "linear", colors: ["#48C6EF", "#6F86D6"] },
        { type: "linear", colors: ["#FF0844", "#FFB199"] },
        { type: "linear", colors: ["#92FE9D", "#00C9FF"] },
        { type: "linear", colors: ["#FF758C", "#FF7EB3"] },
        { type: "linear", colors: ["#868F96", "#596164"] },
        { type: "linear", colors: ["#C79081", "#DFA579"] },
        { type: "linear", colors: ["#ABECD6", "#FBED96"] },
        { type: "linear", colors: ["#16A085", "#F4D03F"] },
        { type: "linear", colors: ["#FF5858", "#F09819"] },
        { type: "linear", colors: ["#E14FAD", "#F9D423"] },
        { type: "linear", colors: ["#C1C161", "#D4D4B1"] },
        { type: "linear", colors: ["#CBBACC", "#2580B3"] },
        { type: "linear", colors: ["#FF1B6B", "#45CAFF"] },
        { type: "linear", colors: ["#432371", "#FAAE7B"] },
        { type: "linear", colors: ["#EF745C", "#34073D"] },
        { type: "linear", colors: ["#FFA8BD", "#242ACF"] },
        { type: "linear", colors: ["#83F5E5", "#E761BD"] },
        { type: "linear", colors: ["#A4C6B8", "#5E435D"] },
        { type: "linear", colors: ["#DCF180", "#35518A"] },
        { type: "linear", colors: ["#22052D", "#CCB3D1"] },
        { type: "linear", colors: ["#E2D9D2", "#AAC9CE"] },
        { type: "linear", colors: ["#B6B3C4", "#DCC2CD"] },
        { type: "linear", colors: ["#A5C7B7", "#5D4257"] },
        { type: "linear", colors: ["#04619F", "#000000"] },
        { type: "linear", colors: ["#B82E1F", "#000000"] },
        { type: "linear", colors: ["#D58936", "#69140E"] },
        { type: "linear", colors: ["#44000B", "#E0455F"] },
        { type: "linear", colors: ["#313131", "#6DADDB"] },
        { type: "linear", colors: ["#59090C", "#DA898C"] },
        { type: "linear", colors: ["#E7C1CE", "#F2D6D2"] },
        { type: "linear", colors: ["#F4DCD0", "#BDBBC0"] },
        { type: "linear", colors: ["#A5CAD2", "#ED8897"] },
        { type: "linear", colors: ["#A7D676", "#83C8B4"] },
        { type: "linear", colors: ["#EEBD89", "#D13ABD"] },
        { type: "linear", colors: ["#AEBAF8", "#9600FF"] },
        { type: "linear", colors: ["#F6EA41", "#F048C6"] },
        { type: "linear", colors: ["#FF8DDB", "#BB73E0"] },
        { type: "linear", colors: ["#C1FCD3", "#0CCDA3"] },
        { type: "linear", colors: ["#AEBAF8", "#C973FF"] },
        { type: "linear", colors: ["#F2F5D0", "#F9957F"] },
        { type: "linear", colors: ["#D592FF", "#B60F46"] },
        { type: "linear", colors: ["#F6EFA7", "#FF0078"] },
        { type: "linear", colors: ["#BFFFC7", "#849B5C"] },
        { type: "linear", colors: ["#E65758", "#771D32"] },
        { type: "linear", colors: ["#C22ED0", "#5FFAE0"] },
        { type: "linear", colors: ["#9FA5D5", "#E8F5C8"] },
        { type: "linear", colors: ["#F2BAE8", "#0C7BB3"] },
        { type: "linear", colors: ["#F6B2E1", "#58126A"] },
        { type: "linear", colors: ["#D9ECC7", "#07A3B2"] },
        { type: "linear", colors: ["#CCFBFF", "#EF96C5"] },
        { type: "linear", colors: ["#50D5B7", "#067D68"] },
        { type: "linear", colors: ["#F2ECB6", "#A96F44"] },
        { type: "linear", colors: ["#FEA858", "#ED765E"] },
      ],
      defaultsImages: {},
      defaultsLoading: false,
      selectedLang: 0,
      isWriting: false,
      langItems: [
        { value: "fa", text: "Fa | فارسی", name: "فارسی", flag: "🇮🇷" },
        { value: "en", text: "En | انگلیسی", name: "انگلیسی", flag: "🇬🇧" },
      ],
      rules: {
        empty: (v) => (!!v && v.length >= 3) || "حداقل ۳ کاراکتر باید وارد شود!",
        spellChecker: (v) =>
          !v ||
          this.spellChecker(v) ||
          `متن وارد شده باید به زبان ${this.computedSelectedLang.name} باشد!`,
      },
      translatedText: "",
    };
  },

  watch: {
    computedValue: {
      deep: true,
      handler(val) {
        console.log(val);
      },
    },
  },

  mounted() {
    this.getDefaultBg();
  },

  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    computedSelectedLang() {
      return this.langItems[this.selectedLang];
    },
  },

  methods: {
    debounceTranslate() {
      this.isWriting = true;

      debounce(() => {
        let lang = this.langItems[this.selectedLang].value;

        if (lang === "fa")
          design
            .translatePrompt(this.prompt)
            .then(({ data }) => (this.translatedText = data.data["destination-text"]))
            .finally(() => (this.isWriting = false));
        else this.isWriting = false;
      }, 2000);
    },
    spellChecker(input) {
      const reg = {
        en: /[\u0600-\u06FF\u06F0-\u06F9]+/,
        fa: /[]+/,
      };

      return Array.from(input).every(
        (char) => !reg[this.computedSelectedLang.value].test(char)
      );
    },
    generate() {
      this.loading = true;

      let p =
        this.langItems[this.selectedLang].value === "fa"
          ? this.translatedText
          : this.prompt;

      design
        .generatePixlr(p)
        .then(({ data }) => {
          this.generatedImages.push(data.data[0].link);
          this.computedValue.type = "image";
          this.computedValue["image"] = data.data[0].link;
          this.$emit("change", "bg");
        })
        .finally(() => (this.loading = false));
    },

    generateAi(e) {
      console.log("image", e);
      let image = "data:image/png;base64," + e;

      this.loading = true;
      this.generatedImages.push(image);
      this.computedValue.type = "image";
      this.computedValue["image"] = image;
      this.$emit("change", "bg");
      this.loading = false;
    },
    setBg(type, value) {
      this.computedValue.type = type;
      this.computedValue[type] = value;
      this.$emit("change", "bg");
    },
    getDefaultBg() {
      this.defaultsLoading = true;

      design
        .getDefaultBackgrounds()
        .then(({ data }) => (this.defaultsImages = data.data))
        .finally(() => (this.defaultsLoading = false));
    },
  },
};
</script>

<style scoped lang="scss">
.v-input >>> textarea {
  resize: none;
}

.imported-images {
  display: grid;
  gap: 8px;
  grid-template-columns: repeat(3, minmax(0, 2fr));
  margin: 0 16px 8px;
}

.imported-images > div {
  height: fit-content;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;

  &:before,
  &:after {
    opacity: 0;
    transition: all 0.15s ease-in-out;
    position: absolute;
    z-index: 1;
    color: white;
  }

  &:before {
    content: "";
    inset: 0;
    background: rgba(0, 0, 0, 0.4);
  }

  &:after {
    content: "+";
    font-size: x-large;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.imported-images > div:hover {
  &:before,
  &:after {
    opacity: 1;
  }
}
</style>
